import React, { useEffect, useState  } from "react";
import Grid from "../../assets/Grid.png";
import "../../Css/Term.css";
import { Helmet } from "react-helmet";
import Navbar from "./Navbar";
import Footer from "./Footer";
// import { Script } from "../../Utils/Script";


const Term = () => {
    const sections = [
 { id: "information-we-collect", label: "TERMS OF USE" },
  { id: "consent", label: "DEFINITIONS" },
  { id: "disclosure", label: "Account Registration and Security" },
  { id: "payment", label: "Account Registration" },
  { id: "third-party-sellers", label: "Security of Your Account" },
  { id: "security", label: "Account Security Measures" },
  { id: "cookies", label: "Immediate Reporting of Unauthorized Activity" },
  { id: "age-of-consent", label: "Termination or Suspension of Account" },
  { id: "changes-to-this-privacy-policy", label: "Delivery Partner Responsibilities" },
  { id: "payment-structure", label: "Payment Structure" },
  { id: "payment-schedule", label: "Payment Schedule" },
  { id: "eligibility", label: "Eligibility" },
  { id: "independent-contractor-status", label: "Independent Contractor Status" },
  { id: "delivery-responsibilities", label: "Delivery Responsibilities" },
  { id: "termination-of-agreement", label: "Termination of Agreement" },
  { id: "dispute-resolution", label: "Dispute Resolution" },
  { id: "insurance-and-protection", label: "Insurance and Protection" },
  { id: "indemnification", label: "Indemnification" },
  { id: "amendments", label: "Amendments" },
  { id: "privacy-and-data-protection", label: "Privacy and Data Protection" },
  { id: "tax-compliance-and-gst-adherence", label: "Tax Compliance and GST Adherence" },
  { id: "contact-us", label: "Contact Us" },
  { id: "customer-support", label: "Customer Support" },
  { id: "how-to-contact-customer-support", label: "How to Contact Customer Support" },
];
const [activeSection, setActiveSection] = useState(sections[0].id);
const handleTocClick = (id) => {
  setActiveSection(id);

  const element = document.getElementById(id);
  if (element) {
    const yOffset = -120;
    const y =
      element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
  }
};

  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  useEffect(() => {
  const handleScroll = () => {
    let currentSection = sections[0].id;

    for (const section of sections) {
      const element = document.getElementById(section.id);
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top <= 140) {
          currentSection = section.id;
        }
      }
    }

    setActiveSection(currentSection);
  };

  window.addEventListener("scroll", handleScroll);
  handleScroll();

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);

// useEffect(() => {
//   Script();
// }, []);

  return (
    <>
     <Helmet>
        <title>Terms & Conditions  — How Packky Collects & Protects Your Data </title>

        <meta
          name="description"
          content="Understand how Packky (powered by Chaafo) collects, uses, and protects personal data for delivery partners and customers in compliance with Indian data protection laws."
        />
      </Helmet>
    <Navbar/>
   <div className="w-full">
  <section>
    <div
      className="mx-auto flex h-[320px] w-full items-center px-4 sm:h-[260px] sm:px-8 md:h-[300px] md:px-16 lg:h-[320px] lg:px-20"
      style={{
        background:
          "linear-gradient(180deg, #fff, #0000), radial-gradient(circle at 10% 100%, #febca1 1%, #0000 30%), radial-gradient(circle at 40% 100%, #8cddff 10%, #0000 35%), radial-gradient(circle at 100% 100%, #ffd18c 15%, #0000 55%)",
      }}
    >
      <div>
        <p className="mb-4 text-[16px] mt-28 font-medium text-[#6b6b6b] sm:text-[24px] md:mb-6 md:text-[28px]">
          Packky (powered by Chaafo)
        </p>

        <h2 className="text-[22px] font-semibold uppercase leading-none text-[#212529] sm:text-[24px] md:text-[26px]">
          Terms & Conditions
        </h2>
      </div>
    </div>
  </section>
</div>
{/* <div
  className="bg-[#EEFAFF] bg-cover bg-center px-3 py-6 sm:px-4 sm:py-8 md:py-10"
  style={{
    backgroundImage: `url(${Grid})`,
  }}
> */}
<div
  className="bg-[#EEFAFF] bg-no-repeat bg-top px-3 py-6 sm:px-4 sm:py-8 md:py-10"
  style={{
    backgroundImage: `url(${Grid})`,
    backgroundSize:
      window.innerWidth < 640
        ? "1100px auto"
        : window.innerWidth < 1024
          ? "1400px auto"
          : "2200px auto",
    backgroundPosition: "top center",
  }}
>
<div>
      <section className="mx-auto max-w-[1720px] px-0 py-6 sm:px-2 md:px-4 lg:px-10 lg:py-12">
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
        <aside className="hidden lg:col-span-4 lg:block xl:col-span-4">
            <div className="lg:sticky lg:top-[110px]">
              <div className="rounded-2xl bg-white p-6 shadow-sm">
                <h3 className="mb-5 text-[18px] font-semibold leading-tight text-[#f97936]">
                  Table of Content
                </h3>

                <ul className="space-y-2">
                  {sections.map((section) => (
                    <li key={section.id}>
                      <button
                        type="button"
                        onClick={() => handleTocClick(section.id)}
                        className={`w-full rounded-xl px-4 py-3 text-left text-[14px] transition ${
  activeSection === section.id
    ? "bg-[#f0e3da] font-semibold text-[#f97936]"
    : "text-gray-600 hover:bg-gray-100"
}`}
                      >
                        {section.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </aside>

          <main className="lg:col-span-8 xl:col-span-8">
  <div className="pt-0">
    <div className="rounded-2xl bg-white p-4 sm:p-6 md:p-8 lg:p-10">
      <div className="px-0 py-3 text-[20px] font-semibold leading-snug text-[#f97936] sm:text-3xl lg:px-5 lg:text-4xl">
        TERMS AND CONDITIONS PACKKY (powered by Chaafo)
      </div>

      <div className="px-0 lg:px-5">
                  <p className="text-[16px]">
                  These Terms and Conditions (“Agreement”) govern your use of the Packky (powered by Chaafo) platform as a delivery partner ("you" or "Delivery Partner"). By accessing or using the Packky (powered by Chaafo) platform, you agree to comply with and be bound by this Agreement. If you do not agree to these terms, do not use the Packky (powered by Chaafo) platform or services. Please read these Terms and Conditions ("Terms", "Terms and Conditions") carefully before using the https://www.packky.com website (the "Service") operated by Packky (powered by Chaafo)("us", "we", or "our").
                  </p>

                  <h2
                    id="information-we-collect"
                    className="scroll-mt-[120px] text-[#525252] pb-2 pt-2 text-[20px] font-semibold"
                  >
                    TERMS OF USE:
                  </h2>
                  <p className="text-[16px]">
                   If you please grant us the request, we can, at some intervals, send you emails notifying you about the store, its new stock, or any relevant changes. However, we may need to gather some information, not limited to, your name and email for the purposes of buying or selling. Furthermore, the system automatically collects your IP address whenever you access our site. That allows us to know the system and the browser that is being used.
                  </p>

                  <h2
                    id="consent"
                    className="scroll-mt-[120px] pb-2 pt-2 text-[#525252] text-[20px] font-semibold"
                  >
                    DEFINITIONS:
                  </h2>
                 <p className="break-words text-[15px] leading-6 mt-2 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        <b>“Acceptance”</b> means your affirmative action of
                        clicking on the box against the words “I Accept”
                        provided at the end of these T&Cs, by which action, you
                        unequivocally accept these T&Cs and any modifications
                        thereof.
                      </p>

                      <p className="break-words text-[15px] leading-6 mt-2 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        <b>“Agreement”</b> shall mean these T&Cs executed
                        between Packky (powered by Chaafo) and the Delivery Partner(s) pursuant to
                        which the Delivery Partner(s) has agreed to undertake
                        Delivery Services.
                      </p>
                      <p className="break-words text-[15px] leading-6 mt-2 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        <b>“Applicable Law(s)”</b> shall mean and include any
                        law, statute, ordinance, rule, regulation, guideline,
                        policy, or other pronouncement having the effect of a
                        law in India, is in effect or which may come into effect
                        on a future date.
                      </p>
                      <p className="break-words text-[15px] leading-6 mt-2 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        <b>“Customer(s)”</b> shall mean the customers who place
                        an order with the Merchant(s).
                      </p>
                      <p className="break-words text-[15px] leading-6 mt-2 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        <b>
                          “Delivery Partner(s)” or “You” or “Your” or “Yourself”
                        </b>{" "}
                        shall mean the individuals who agree to provide Delivery
                        Services to Packky (powered by Chaafo) and the Customer(s) as per the T&Cs
                        contained hereunder.
                      </p>

                      <p className="break-words text-[15px] leading-6 mt-2 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        <b>“Delivery Partner Information”</b> shall mean and
                        include any personal data collected from the Delivery
                        Partner(s) including, KYC documents, valid & operational
                        PAN card, bank account details, copies of a valid
                        vehicle registration certificate, driving license,
                        location data, photographs,nominee details and any other
                        information as may be required by Packky (powered by Chaafo) or its
                        authorised third parties or agents, from time to time.
                      </p>

                      <p className="break-words text-[15px] leading-6 mt-2 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        <b>“Delivery Services”</b> shall mean the services
                        provided by any of the Delivery Partner(s) for
                        collecting and delivering the items ordered by the
                        Customer(s) from the Merchant(s).
                      </p>
                      <p className="break-words text-[15px] leading-6 mt-2 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        <b>“Merchant(s)”</b>shall mean an individual(s)/entity
                        from which the Customer(s) places an order.
                      </p>

                      <p className="break-words text-[15px] leading-6 mt-2 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        <b>“Platform Services”</b>shall mean the services
                        provided by Packky (powered by Chaafo) to the Delivery Partner(s) through
                        the Packky (powered by Chaafo) DP Platform including receiving orders placed
                        by the Customer(s), access to the benefits and providing
                        any Delivery Partner(s) assistance etc.
                      </p>
                      <p className="break-words text-[15px] leading-6 mt-2 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        <b>“Packky (powered by Chaafo) DP Platform”</b>shall mean the mobile
                        application developed by Packky (powered by Chaafo) for the purpose of
                        connecting the Delivery Partner(s) with the Merchant(s)
                        and the Customer(s) to undertake the Delivery Services.
                        It shall also include for all purposes the mobile
                        interface or application provided to the Delivery
                        Partner(s) that enables the Delivery Partner(s) to
                        undertake Delivery Services as well as enables Packky (powered by Chaafo),
                        to track the order status and provide assistance to the
                        Delivery Partner(s) etc.
                      </p>

                      <p className="break-words text-[15px] leading-6 mt-2 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        <b>Packky (powered by Chaafo) Overview:</b>Packky (powered by Chaafo) partners with restaurants
                        to provide delivery services through our platform,
                        offering delivery partners (drivers) the ability to
                        transport restaurant orders to customers.
                      </p>
                      <p className="break-words text-[15px] leading-6 mt-2 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        <b>Agreement Acceptance:</b>By signing up or using the
                        Packky (powered by Chaafo) platform, you (the delivery partner) agree to the
                        terms and conditions outlined here.
                      </p>

                  <h2
                    id="disclosure"
                    className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]"
                  >
                    Account Registration and Security
                  </h2>
                  <ul className="terms-list">
                        <li className="terms-list-item">
                          You agree to create an account with Packky (powered by Chaafo) and provide
                          accurate information during the registration process.
                        </li>

                        <li className="terms-list-item">
                          You are responsible for maintaining the
                          confidentiality of your account and password and are
                          fully responsible for all activities that occur under
                          your account.
                        </li>
                        <li className="terms-list-item">
                          You agree to notify Packky (powered by Chaafo) immediately of any
                          unauthorized use of your account or any other breach
                          of security.
                        </li>
                      </ul>

                      <p className="break-words text-[15px] leading-5 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        As a delivery partner on the Packky (powered by Chaafo) platform, it’s
                        essential to understand the process of account
                        registration and the security measures we put in place
                        to ensure the safety and integrity of both your personal
                        information and the delivery operations. The following
                        outlines the terms and guidelines for account
                        registration, security, and responsibilities associated
                        with your account.
                      </p>

                  <h2
                    id="payment"
                    className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]"
                  >
                    Account Registration
                  </h2>
                   <p className="break-words text-[15px] leading-7 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        To become a delivery partner with Packky (powered by Chaafo), you must
                        complete the registration process on our platform. By
                        registering, you agree to provide accurate and
                        up-to-date information and comply with the terms
                        outlined in this Agreement.<br></br>
                        <span className="mt-2">
                          Required Information for Registration:
                        </span>
                      </p>

                      <ul className="terms-list mb-5">
                        <li className="terms-list-item">
                          <b>Full Name:</b>Your legal name to identify you as a
                          delivery partner.
                        </li>
                        <li className="terms-list-item">
                          <b>Email Address:</b>To receive important
                          communication, updates, and notifications.
                        </li>
                        <li className="terms-list-item">
                          <b>Phone Number:</b>To facilitate communication
                          between you, customers, and Packky (powered by Chaafo) support.
                        </li>
                        <li className="terms-list-item">
                          <b>Driver’s License:</b>For identity verification and
                          to confirm you are legally able to drive (if
                          applicable).
                        </li>
                        <li className="terms-list-item">
                          <b>Vehicle Information:</b>If you use a vehicle for
                          deliveries, you'll need to provide details, such as
                          make, model, license plate number, and proof of
                          insurance.
                        </li>
                        <li className="terms-list-item">
                          <b>Bank/Payment Details:</b>To facilitate payments for
                          completed deliveries.
                        </li>
                        <li className="terms-list-item">
                          <b>Profile Picture:</b>A clear photo of yourself for
                          identification purposes (if requested).
                        </li>
                        <li className="terms-list-item ">
                          <b>Other Identification:</b>You may be required to
                          submit additional documents, such as government-issued
                          identification, background check consent, or any other
                          information required by local regulations.
                        </li>
                      </ul>

                  <h2
                    id="third-party-sellers"
                    className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]"
                  >
                    Security of Your Account:
                  </h2>
                  <p className=" text-[16px] leading-5">
                  Account security is paramount to ensure that your personal data, delivery information, and transaction details are protected. By registering and using the Packky (powered by Chaafo) platform, you are responsible for safeguarding your account from unauthorized access and any misuse.
                  </p>

                  <h2
                    id="security"
                    className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]"
                  >
                    Account Security Measures:
                  </h2>
                  <ul className="terms-list">
                        <li className="terms-list-item">
                          <b>Password Protection:</b>
                          You must create a strong, unique password for your
                          account. The password should include a combination of
                          letters, numbers, and special characters to prevent
                          unauthorized access. You should never share your
                          password with anyone.
                        </li>

                        <li className="terms-list-item">
                          {" "}
                          <b>Device Security:</b>When using the Packky (powered by Chaafo) platform,
                          ensure that your mobile device or computer is
                          protected with a password, fingerprint, or other
                          security measures. Avoid using public or unsecured
                          networks to access the platform.
                        </li>
                        <li className="terms-list-item">
                          <b>Account Access:</b>Do not allow unauthorized
                          individuals to access or use your account. You are
                          solely responsible for any activity that occurs under
                          your account.
                        </li>
                        <li className="terms-list-item">
                          <b>Data Encryption:</b>We utilize secure communication
                          protocols (e.g., HTTPS) to encrypt the transmission of
                          sensitive information, such as payment details, during
                          your interactions on the platform.
                        </li>
                      </ul>

                  <h2
                    id="cookies"
                    className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]"
                  >
                    Immediate Reporting of Unauthorized Activity:
                  </h2>
                 <ul className="terms-list">
                        <li className="terms-list-item">
                          If you suspect that your account has been compromised
                          or notice any suspicious activity, you must notify
                          Packky (powered by Chaafo) immediately. We will take necessary steps to
                          secure your account and investigate the issue.
                        </li>

                        <li className="terms-list-item">
                          {" "}
                          You can contact Packky (powered by Chaafo) support through the contact
                          details provided in the platform or on the website to
                          report any security concerns.
                        </li>
                      </ul>

                  <h2
                    id="age-of-consent"
                    className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]"
                  >
                    Termination or Suspension of Account:
                  </h2>
                 <h5 className="break-words text-[15px] leading-7 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        Packky (powered by Chaafo) reserves the right to suspend or terminate your
                        delivery partner account if:
                      </h5>

                      <ul className="terms-list">
                        <li className="terms-list-item">
                          You violate the terms and conditions of this
                          Agreement.
                        </li>

                        <li className="terms-list-item">
                          {" "}
                          Your account has been compromised and you fail to take
                          corrective action.
                        </li>
                        <li className="terms-list-item">
                          {" "}
                          There is fraudulent activity or unauthorized use of
                          your account.
                        </li>
                        <li className="terms-list-item">
                          {" "}
                          You repeatedly fail to comply with the operational
                          guidelines set by Packky (powered by Chaafo).
                        </li>
                      </ul>
                      <p className="break-words text-[15px] leading-7 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        If your account is terminated or suspended for any
                        reason, you will be notified, and any pending payments
                        due to you will be processed as per the payment terms.
                      </p>

                  <h2
                    id="changes-to-this-privacy-policy"
                    className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]"
                  >
                    Delivery Partner Responsibilities
                  </h2>
                  <ul className="terms-list">
                        <li className="terms-list-item">
                          <b>Acceptance of Deliveries:</b>
                          By accepting a delivery, you agree to complete the
                          delivery within the agreed-upon timeframe and follow
                          the instructions provided by Packky (powered by Chaafo) and the customer.
                          If driver not deliver food to the customers door
                          within time and that the customer deny to pay the
                          order cost, in that case Packky (powered by Chaafo) not pay any other cost
                          to the driver against order.
                        </li>

                        <li className="terms-list-item">
                          <b>Quality of Service:</b> You must provide
                          high-quality and professional service at all times,
                          ensuring the safety of the goods being delivered and
                          maintaining communication with the customer and Packky (powered by Chaafo)
                          when necessary.
                        </li>
                        <li className="terms-list-item">
                          <b>Compliance with Laws:</b> You must comply with all
                          applicable laws, regulations, and rules, including
                          traffic laws, and ensure your vehicle or mode of
                          transport is safe, properly insured, and roadworthy.
                        </li>
                        <li className="terms-list-item">
                          <b>No Unauthorized Sharing of Information:</b> You
                          agree not to disclose any personal information,
                          business information, or details about PACKKY’S
                          customers to unauthorized third parties.
                        </li>
                        <li className="terms-list-item">
                          <b>Timely and Accurate Deliveries:</b> As a delivery
                          partner with Packky (powered by Chaafo), delivering packages on time and
                          ensuring accuracy is crucial to maintaining customer
                          satisfaction and trust.
                        </li>

                        <li className="terms-list-item">
                          <b>Professional Conduct:</b> Always treat customers
                          with kindness, courtesy, and respect. Greet customers
                          politely upon delivery, address their concerns
                          professionally, and engage in friendly, positive
                          interactions.
                        </li>

                        <li className="terms-list-item">
                          <b>Compliance with Laws and Regulations:</b> Always
                          follow local traffic rules, including speed limits,
                          stop signs, and other road signs. Reckless driving,
                          failure to obey traffic signals, or any other
                          violations of road safety laws can result in
                          accidents, penalties, and termination of your delivery
                          partner account. Regularly inspect your vehicle to
                          ensure that it is in good working order. This includes
                          checking brakes, lights, tires, and safety features. A
                          well-maintained vehicle reduces the risk of accidents
                          and delays.
                        </li>

                        <li className="terms-list-item">
                          <b>Compliance with Laws and Regulations:</b> Always
                          follow local traffic rules, including speed limits,
                          stop signs, and other road signs. Reckless driving,
                          failure to obey traffic signals, or any other
                          violations of road safety laws can result in
                          accidents, penalties, and termination of your delivery
                          partner account. Regularly inspect your vehicle to
                          ensure that it is in good working order. This includes
                          checking brakes, lights, tires, and safety features. A
                          well-maintained vehicle reduces the risk of accidents
                          and delays.
                        </li>

                        <li className="terms-list-item">
                          <b>Maintenance of Delivery Equipment:</b> As a
                          delivery partner with Packky (powered by Chaafo), ensuring that your
                          delivery equipment is in optimal condition is
                          essential for providing timely, efficient, and safe
                          service. Whether you are using a vehicle (car,
                          motorcycle, bicycle, etc.), a scooter, or any other
                          delivery tool, it is your responsibility to maintain
                          these resources to meet safety, operational, and
                          customer satisfaction standards.
                        </li>
                      </ul>

                  <h2
                    id="payment-structure"
                    className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]"
                  >
                    Payment Structure:
                  </h2>
                  <ul className="terms-list">
                        <li className="terms-list-item">
                          <b>Delivery Fees:</b>
                          You will be paid a fixed or variable fee based on the
                          type of delivery, distance, size of the package, or
                          other factors determined by Packky (powered by Chaafo). The delivery fee
                          may be communicated to you in advance or after
                          completing the delivery.
                        </li>

                        <li className="terms-list-item">
                          <b>Bonuses and Incentives:</b> Packky (powered by Chaafo) may offer
                          bonuses or incentives for completing a certain number
                          of deliveries, handling special requests, or
                          delivering within specific timeframes. These bonuses
                          will be added to your overall payment and are subject
                          to the terms and conditions outlined in the Packky (powered by Chaafo)
                          platform.
                        </li>
                        <li className="terms-list-item">
                          {" "}
                          <b>Additional Charges:</b>If applicable, additional
                          charges may be included for services such as rush
                          deliveries, deliveries to hard-to-reach locations, or
                          handling large or specialized items. These charges
                          will be clarified prior to the delivery and added to
                          your payment.
                        </li>
                      </ul>
                      <h2 
                      id="payment-schedule"
                      className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]">Payment Schedule:</h2>

                      <ul className="terms-list">
                        <li className="terms-list-item">
                          <b>Frequency of Payment:</b>
                          Payments for your deliveries will be processed on a
                          regular schedule, typically weekly or bi-weekly.
                          Specific payment dates will be made available to you
                          via the Packky (powered by Chaafo) platform or communication channels.
                        </li>

                        <li className="terms-list-item">
                          <b>Bonuses and Incentives:</b> Payments will be made
                          through the payment method you select (e.g., paytm,
                          phonepe and any other UPI modes, etc.). It is your
                          responsibility to ensure that the payment method on
                          file is accurate and up to date.
                        </li>
                        <li className="terms-list-item">
                          {" "}
                          <b>Payment Methods:</b>If applicable, additional
                          charges may be included for services such as rush
                          deliveries, deliveries to hard-to-reach locations, or
                          handling large or specialized items. These charges
                          will be clarified prior to the delivery and added to
                          your payment.
                        </li>
                        <li className="terms-list-item">
                          <b>Payment Statements:</b> You will receive a detailed
                          payment statement that outlines the number of
                          deliveries completed, payment amounts for each, and
                          any applicable deductions (e.g., service fees or
                          fines). These statements will be available to you on
                          the Packky (powered by Chaafo) platform.
                        </li>
                      </ul>

                      <h2 
                      id="eligibility"
                      className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]">Eligibility:</h2>
                      <h3 className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]">
                        To become a delivery partner, you must:
                      </h3>

                      <ul className="terms-list">
                        <li className="terms-list-item">
                          Be at least 18 years old.
                        </li>

                        <li className="terms-list-item">
                          Must have a Bike, Scooty etc.
                        </li>
                        <li className="terms-list-item">
                          {" "}
                          Have a valid driver’s license (if operating a vehicle)
                          or the necessary permits for using alternative
                          delivery modes (e.g., bicycle, scooter).
                        </li>
                        <li className="terms-list-item">
                          Own or have access to a vehicle or other mode of
                          transport suitable for performing deliveries (in
                          accordance with the services you provide).
                        </li>
                        <li className="terms-list-item">
                          Have necessary insurance coverage for your vehicle, as
                          required by local laws.
                        </li>
                        <li className="terms-list-item">
                          Be legally authorized to work in the jurisdiction
                          where you are providing delivery services. If you fail
                          to meet these eligibility requirements, you are
                          prohibited from using the Packky (powered by Chaafo) platform as a
                          delivery partner.
                        </li>
                      </ul>

                      <h2 
                      id="independent-contractor-status"
                      className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]">
                        Independent Contractor Status:
                      </h2>
                      <p className="break-words text-[15px] leading-5 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        As a delivery partner, you are an independent
                        contractor, not an employee of Packky (powered by Chaafo). You are
                        responsible for your own taxes, expenses, and compliance
                        with any applicable labor and tax laws. You will not be
                        entitled to any benefits (e.g., health insurance, paid
                        time off, or retirement benefits) that would apply to
                        employees of Packky (powered by Chaafo).
                      </p>

                      <h2 
                      id="delivery-responsibilities"
                      className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]">
                        Delivery Responsibilities
                      </h2>
                      <p>As a delivery partner, you agree to:</p>

                      <ul className="terms-list">
                        <li className="terms-list-item">
                          <b>Complete Deliveries Timely and Accurately:</b>
                          Deliver all orders in a timely and professional
                          manner, following all instructions provided by Packky (powered by Chaafo)
                          or the customer.  Handle Goods with Care: Ensure that
                          all goods are handled safely, securely, and with the
                          utmost care to prevent damage, loss, or theft during
                          transit.
                        </li>

                        <li className="terms-list-item">
                          <b>Handle Goods with Care:</b>Ensure that all goods
                          are handled safely, securely, and with the utmost care
                          to prevent damage, loss, or theft during transit.
                        </li>
                        <li className="terms-list-item">
                          <b>Provide Professional Service:</b> Maintain a polite
                          and professional demeanor when interacting with
                          customers and clients.
                        </li>
                        <li className="terms-list-item">
                          <b>Adhere to Delivery Instructions:</b>Follow all
                          delivery instructions as provided through the Packky (powered by Chaafo)
                          platform, including addresses, delivery times, and
                          special handling instructions.
                        </li>
                      </ul>

                      <h2
                      id="termination-of-agreement"
                      className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]">
                        Termination of Agreement
                      </h2>
                      <p>
                        Packky (powered by Chaafo) reserves the right to suspend or terminate your
                        delivery partner account at any time for any of the
                        following reasons:
                      </p>

                      <ul className="terms-list">
                        <li className="terms-list-item">
                          <b>Violation of Terms:</b>
                          Breaching any terms and conditions outlined in this
                          agreement.
                        </li>

                        <li className="terms-list-item">
                          <b>Unprofessional Behavior:</b>Repeatedly failing to
                          maintain professionalism or providing poor customer
                          service.
                        </li>
                        <li className="terms-list-item">
                          <b>Legal Non-Compliance:</b>Failure to maintain
                          necessary licenses, insurance, or to comply with
                          applicable laws.
                        </li>
                        <li className="terms-list-item">
                          <b>Fraud or Misconduct:</b>Engaging in any fraudulent
                          or unethical behavior that affects the integrity of
                          the Packky (powered by Chaafo) platform.
                        </li>
                      </ul>

                      <h2 
                      id="dispute-resolution"
                      className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]">Dispute Resolution</h2>

                      <ul className="terms-list">
                        <li className="terms-list-item">
                          <b>Governing Law:</b>
                          This Agreement will be governed by and construed in
                          accordance with the laws of Jurisdiction.{" "}
                        </li>

                        <li className="terms-list-item">
                          <b>Arbitration:</b>Any disputes or claims arising out
                          of or in connection with this Agreement will be
                          resolved through binding arbitration, rather than in
                          court. You and Packky (powered by Chaafo) agree to resolve any dispute
                          through arbitration under the rules of Arbitration
                          Organization.
                        </li>
                        <li className="terms-list-item">
                          Packky (powered by Chaafo) serves as a &nbsp;
                          <b>delivery partner service provider &nbsp;</b>and acts as a
                          platform connecting delivery partners with merchants
                          or customers who need delivery services. While we
                          facilitate the connection and enable delivery
                          services,
                          <b> &nbsp;
                            Packky (powered by Chaafo) is not responsible for any damages, disputes,
                            or conflicts &nbsp;
                          </b>
                          between delivery partners (drivers) and merchants or
                          customers.
                        </li>
                      </ul>

                      <h2 
                      id="insurance-and-protection"className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]">
                        Insurance and Protection:
                      </h2>

                      <ul className="terms-list">
                        <li className="terms-list-item">
                          <b>Delivery Partner Insurance:</b>Delivery partners
                          are encouraged to have adequate insurance coverage for
                          their vehicle, goods in transit, and any potential
                          damages incurred during the delivery process. Packky (powered by Chaafo)
                          is not responsible for providing insurance or
                          protection for delivery partners or their goods.
                        </li>
                      </ul>

                      <h2
                      id="indemnification" className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]">Indemnification:</h2>
                      <p className="break-words text-[15px] leading-5 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        You agree to defend, indemnify and hold harmless Packky (powered by Chaafo)
                        DP platform and its licensee and licensors, and their
                        employees, contractors, agents, officers and directors,
                        from and against any and all claims, damages,
                        obligations, losses, liabilities, costs or debt, and
                        expenses (including but not limited to attorney's fees),
                        resulting from or arising out of a) your use and access
                        of the Service, by you or any person using your account
                        and password, or b) a breach of these Terms.
                      </p>

                      <h2 
                      id="amendments"
                      className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]">Amendments:</h2>
                      <p className="break-words text-[15px] leading-5 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        Packky (powered by Chaafo) reserves the right to modify or update these
                        Terms and Conditions at any time. You will be notified
                        of any changes, and your continued use of the Packky (powered by Chaafo)
                        platform after the changes will constitute your
                        acceptance of the updated terms.
                      </p>

                      <h2
                      id="privacy-and-data-protection"
                      className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]">
                        Privacy and Data Protection:
                      </h2>

                      <ul className="terms-list">
                        <li className="terms-list-item">
                          <b>Data Collection:</b>By using the Packky (powered by Chaafo) platform,
                          you agree that Packky (powered by Chaafo) may collect and process your
                          personal data, including contact information, payment
                          details, and delivery-related information, in
                          accordance with our privacy policy.
                        </li>

                        <li className="terms-list-item">
                          <b>Confidentiality:</b>You agree to keep all customer
                          information, delivery details, and any proprietary
                          information of Packky (powered by Chaafo) confidential. Unauthorized
                          sharing of this information will result in termination
                          of your account and may result in legal action.
                        </li>
                      </ul>

                      <h2 
                      id="tax-compliance-and-gst-adherence"
                      className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]">
                        Tax Compliance and GST Adherence:
                      </h2>
                      <p className="break-words text-[15px] leading-5 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        Packky (powered by Chaafo) is committed to complying with all applicable tax
                        regulations, including the Goods and Services Tax (GST),
                        in all regions where it operates. We ensure that our
                        platform and services are compliant with local tax laws
                        and regulations, including tax payments and
                        documentation.
                      </p>

                      <p className="break-words text-[15px] mt-2 leading-5 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        <b>Legal Compliance: </b>Packky (powered by Chaafo) adheres to all local,
                        regional, and national tax laws, including GST and other
                        applicable taxes, in the jurisdictions where our
                        delivery services are provided.
                      </p>

                      <p className="break-words text-[15px] mt-2 leading-5 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        <b>GST Registration: </b>Packky (powered by Chaafo) is duly registered for
                        GST, where applicable, and will charge and collect GST
                        on transactions involving delivery services where
                        required by law.
                      </p>

                      <p className="break-words text-[15px] mt-2 leading-5 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        <b>Tax Documentation: </b>Packky (powered by Chaafo) will provide proper
                        documentation for GST purposes to both delivery partners
                        and clients as required by local tax laws.
                      </p>

                      <h2
                      id="contact-us"
                      className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]">Contact Us:</h2>

                      <p className="break-words text-[15px] leading-5 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        We are here to assist you with any questions or concerns
                        you may have about the Packky (powered by Chaafo) platform and delivery
                        services.
                      </p>

                      <h2 
                      id="customer-support"
                      className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]">Customer Support:</h2>

                      <p className="break-words text-[15px] leading-5 text-[#525252] sm:text-[16px] lg:text-[16px]">
                        We’re here to help! If you have any questions, concerns,
                        or issues, please reach out to our Customer Support
                        team. Our team is available to assist you with
                        delivery-related inquiries, account issues, and anything
                        else you need help.
                      </p>

                      <h2 
                      id="how-to-contact-customer-support"
                      className="scroll-mt-[120px] pb-2 pt-2 text-xl font-semibold text-[#525252] sm:text-[20px]">
                        How to Contact Customer Support:
                      </h2>

                      <ul className="terms-list">
                        <li className="terms-list-item">
                          <b>Email:</b>For general inquiries or support-related
                          questions, please email us at support@packky.com. Our
                          team will respond as quickly as possible, typically
                          within 24 hours.
                        </li>

                        <li className="terms-list-item">
                          <b>Phone:</b>Call us at +91-9958853167 for urgent
                          inquiries or assistance. Our phone lines are available
                          during business hours (Monday to Friday, 9:00 AM to
                          6:00 PM)
                        </li>
                      </ul>
                </div>
              </div>
            </div>
          </main>
        </div>
      </section>
    </div>
    </div>
    <Footer />
    </>
      );
};

export default Term;